import { useEffect, useMemo, useState } from "react";
import { Object3D } from "three";

import { LoadableGLTFResource } from "../../loader/LoadableGLTFResource";

export function useModelInstance(gltfUrl: string): Object3D | null {
  const resource = useMemo(() => new LoadableGLTFResource(gltfUrl), [gltfUrl]);
  const [instance, setInstance] = useState<Object3D | null>(null);

  useEffect(() => {
    let model: Object3D | null = null;

    const doLoad = async () => {
      await resource.load();
      const gltf = resource.getResource();
      model = gltf.scene.clone();
      setInstance(model);
    };

    doLoad();

    return () => {
      if (model) model.removeFromParent();
    };
  }, [resource]);

  return instance;
}
